'use strict';

import Vue from 'vue';
import Api from '@/api/interview.js';
import videointerview from './interview/videointerview';
import test from './interview/test';
import visibility from './interview/visibility';
import refuse from './interview/refuse';
import application from './interview/application';

const state = {
  loading: true,
  error: null,
  interview: null,
  country: null,
  company_language: null
};

const actions = {
  fetch({ dispatch, commit }, { token }) {
    commit('fetch');

    return Api.fetchOne(token)
      .then(data => {
        // determine active process
        const activeProcessName =
          data.meta && data.meta.active_process ? data.meta.active_process : null;

        dispatch('process/setName', activeProcessName, { root: true });
        // --
        commit('fetchSuccess', data);
      })
      .catch(err => commit('fetchFailure', err));
  }
};

const mutations = {
  fetch(state) {
    Vue.set(state, 'interview', null);
    state.loading = true;
  },

  fetchSuccess(state, data) {
    state.interview = data;
    state.loading = false;
  },

  fetchFailure(state, err) {
    state.error = err;
    state.loading = false;
  },

  set_country(state, data) {
    state.country = data;
  },

  set_company_language(state, data) {
    state.company_language = data;
  }
};

const getters = {
  error(state) {
    return state.error;
  },

  loading(state) {
    return state.loading;
  },

  country(state) {
    return state.country;
  },

  company_language(state) {
    return state.company_language;
  },

  one(state) {
    return state.interview || { name: '', modules: [] };
  },

  vacancy(state, getters) {
    return getters['one'].vacancy;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules: {
    videointerview,
    test,
    refuse,
    application,
    visibility
  }
};
